import { ErrorHandler, Injectable } from "@angular/core";
import { NgModule } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable({
  providedIn: "root",
})
export class AppErrorHandler implements ErrorHandler {
  handleError(error: any) {
    if (error == null) logger.out.error("null uncaught Error");
    else {
      logger.out.error(error);
    }

    if (error != null && error instanceof ErrorEvent) {
      logger.out.error(`${error.filename}#${error.lineno}:${error.colno} ${error.message}`);
    }
  }
}
